export interface Question {
  area: string
  tag: string
  tagClass: string
  q: string
  si: string
  no: string
}

export const questions: Question[] = [
  {
    area: 'PIPELINE & CAPTACIÓN',
    tag: 'BUILD',
    tagClass: 'var(--build)',
    q: '¿Tienes un sistema activo que genera prospectos interesados en ser agentes de seguros todas las semanas, sin depender de referidos o contactos personales?',
    si: 'Tienes un canal de captación activo.',
    no: 'Dependes de lo que llegue. Sin sistema de captación, no hay pipeline.',
  },
  {
    area: 'PIPELINE & CAPTACIÓN',
    tag: 'BUILD',
    tagClass: 'var(--build)',
    q: '¿Tus prospectos entran a un CRM donde puedes ver en qué etapa está cada uno (nuevo, en proceso de licencia, activo, inactivo)?',
    si: 'Tienes visibilidad de tu pipeline.',
    no: 'Si no está en un CRM, no existe. Estás operando a ciegas.',
  },
  {
    area: 'ACOMPAÑAMIENTO DE LICENCIA',
    tag: 'TRACK',
    tagClass: 'var(--track)',
    q: '¿Tienes un proceso documentado paso a paso para acompañar a tus reclutas desde que se comprometen hasta que obtienen su licencia?',
    si: 'Tu proceso de licencia tiene estructura.',
    no: 'Sin proceso, cada recluta navega solo. El abandono es predecible.',
  },
  {
    area: 'ACOMPAÑAMIENTO DE LICENCIA',
    tag: 'TRACK',
    tagClass: 'var(--track)',
    q: '¿Haces seguimiento cada 2-3 días a los reclutas que están estudiando para el examen de licencia?',
    si: 'Tu seguimiento es consistente.',
    no: 'Cada día sin contacto es un día más cerca del abandono.',
  },
  {
    area: 'ACTIVACIÓN PRIMER MES',
    tag: 'TRACK',
    tagClass: 'var(--track)',
    q: '¿Tus agentes nuevos cierran su primera póliza dentro de los primeros 21 días después de obtener su licencia?',
    si: 'Tu activación es rápida.',
    no: 'Si la primera venta tarda más de 21 días, la probabilidad de abandono se dispara.',
  },
  {
    area: 'ACTIVACIÓN PRIMER MES',
    tag: 'TRACK',
    tagClass: 'var(--track)',
    q: '¿Le pides a cada agente un reporte semanal con números concretos (contactos, citas, cierres)?',
    si: 'Tienes visibilidad de su actividad.',
    no: 'Sin números no hay diagnóstico. Solo esperanza.',
  },
  {
    area: 'MÉTRICAS & CONTROL',
    tag: 'SCALE',
    tagClass: 'var(--scale)',
    q: '¿Sabes exactamente cuál es tu tasa de retención a 90 días? (De cada 10 que entran, ¿cuántos siguen produciendo después de 3 meses?)',
    si: 'Conoces tu métrica clave de retención.',
    no: 'Si no mides la retención, no puedes mejorarla.',
  },
  {
    area: 'MÉTRICAS & CONTROL',
    tag: 'SCALE',
    tagClass: 'var(--scale)',
    q: '¿Tienes una revisión semanal estructurada donde evalúas el rendimiento de cada agente de tu equipo?',
    si: 'Tu control es sistemático.',
    no: 'Sin revisión semanal, los problemas se acumulan hasta que es tarde.',
  },
  {
    area: 'DUPLICACIÓN & ESCALA',
    tag: 'SCALE',
    tagClass: 'var(--scale)',
    q: '¿Alguno de tus agentes ya está reclutando y activando a su propia gente sin depender de ti?',
    si: 'Tu sistema se está duplicando.',
    no: 'Si todo depende de ti, no tienes una agencia. Tienes un trabajo.',
  },
  {
    area: 'DUPLICACIÓN & ESCALA',
    tag: 'SCALE',
    tagClass: 'var(--scale)',
    q: '¿Tienes documentado tu proceso de reclutamiento y activación de forma que otra persona pueda ejecutarlo sin ti?',
    si: 'Tu sistema es transferible.',
    no: 'Si el conocimiento está en tu cabeza, no se puede duplicar.',
  },
]
